// In some cases, the GL Classification code field is readonly when the page first displays.
// In these cases, the Additional Information section should also display (as it does when the user
// selects a class code from the list.
//
// This script checks that the GL Classification field is readonly and that the page is being displayed for the
// first time. If both of these conditions are true, then we trigger the IPDTR call on the GL Classifications field.
//
//
// Setup the namespace for this logic
var makeGLClassCodeIPDTRCall = makeGLClassCodeIPDTRCall || {};


makeGLClassCodeIPDTRCall.initialize = function() {
	ap.consoleInfo("makeGLClassCodeIPDTRCall initialize!");

	var field = page.getField("GeneralLiabilityClassificationClassCode");
	if (field.readOnly && page.isFirstView) {
		field.makeIntraPageDTRRequest();
	}
};
